module.exports = __webpack_public_path__ + "static/media/mex.e5b9ebdf.png";